import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

// API access for the kitchen view of customer food orders.
export default function useFoodOrderKitchen() {
  const { sendRequest, isLoading, error } = useHttp();
  const authCtx = useContext(AuthContext);

  const authHeaders = useCallback(
    () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + authCtx.token }),
    [authCtx.token]
  );

  // Active orders (in preparation / ready) with the exact order time.
  const getKitchenOverview = useCallback(
    async branchId => {
      return await sendRequest({
        url: '/api/v1/foodOrder/kitchen/overview',
        method: 'GET',
        headers: authHeaders(),
        params: branchId ? { branchId } : {},
      });
    },
    [sendRequest, authHeaders]
  );

  // Advance an order: inPreparation -> ready -> pickedUp, or cancelled.
  const updateOrderStatus = useCallback(
    async (orderId, status) => {
      return await sendRequest({
        url: `/api/v1/foodOrder/kitchen/${orderId}/status`,
        method: 'PATCH',
        headers: authHeaders(),
        body: { status },
      });
    },
    [sendRequest, authHeaders]
  );

  return { getKitchenOverview, updateOrderStatus, isLoading, error };
}
